import { Skeleton, Space, Tag, Typography } from '@sravni/react-design-system';

import styles from './SlotSelect.module.scss';

const { Heading } = Typography;

type TSelectSlot = {
  id: string;
  label: string;
  value: string;
};

type Props = {
  label: string;
  isLoading?: boolean;
  value?: string | null;
  onSelect?: (value?: string) => void;
  slots?: TSelectSlot[];
  skeletonSlotsCount?: number;
  skeletonWidth?: number;
};

export const SlotSelect = ({
  label,
  slots = [],
  value,
  onSelect,
  isLoading = false,
  skeletonSlotsCount = 3,
  skeletonWidth = 30,
}: Props) => (
  <Space
    direction="vertical"
    size={12}
  >
    <Heading level={6}>{label}</Heading>

    <Space
      size={12}
      wrap
    >
      {isLoading
        ? Array.from({ length: skeletonSlotsCount }).map((_, index) => (
            <div
              // eslint-disable-next-line react/no-array-index-key
              key={index}
              style={{ width: `${skeletonWidth}px` }}
            >
              <Skeleton.Paragraph className={styles.slotSkeleton} />
            </div>
          ))
        : slots?.map(({ value: innerValue, label: innerLabel, id }) => {
            return (
              <Tag
                size={36}
                key={id}
                active={value === innerValue}
                onClick={() => onSelect?.(innerValue)}
              >
                {innerLabel}
              </Tag>
            );
          })}
    </Space>
  </Space>
);
